import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogRef } from '../../dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';

@Component({
    selector: 'app-print-popup',
    templateUrl: './print-popup.component.html',
    standalone: false
})
export class PrintPopupComponent implements OnInit {
  config:any = {print:500}
  PRINT_ALLOWED = 10000;
  constructor( public dialog: DialogRef,public dialogConfig: DialogConfig,public roleService:RolePermissionService,public appService:AppService,public alert:AlertsService) { }

  ngOnInit(){
   
   
  }
  printBtn(type){
    if(type == "print_all"){
      if(this.config.print > this.PRINT_ALLOWED){
        this.alert.error("Maximum allowed records for print : "+this.PRINT_ALLOWED)
        return;
      }
    }
    this.dialog.close({type:type,print:this.config.print});
  }
 
}
